import { Link } from "react-router-dom";
import { Tag, Calendar, Truck, Handshake, ArrowRight } from "lucide-react";

const PERKS = [
  { Icon: Tag, label: "Tarifs préférentiels" },
  { Icon: Calendar, label: "Facturation mensuelle" },
  { Icon: Truck, label: "Prise en charge rapide" },
  { Icon: Handshake, label: "Partenariat sur mesure" },
];

export default function B2BSection() {
  return (
    <section className="bg-surface-50 py-14 sm:py-16 lg:py-20" data-testid="b2b-section">
      <div className="max-w-6xl mx-auto px-4 lg:px-6">
        <div className="bg-white rounded-2xl border border-surface-200 shadow-card overflow-hidden lg:grid lg:grid-cols-[1fr_320px]">
          <div className="p-8 lg:p-12">
            <div className="inline-flex items-center gap-2 bg-brand-50 text-brand rounded-full px-3 py-1 text-xs font-bold mb-4">
              Professionnels
            </div>
            <h2 className="text-2xl lg:text-3xl font-extrabold text-txt-900">
              Vous êtes un professionnel ?
            </h2>
            <p className="text-txt-500 mt-3 max-w-lg">
              Nous travaillons avec les garages, concessions, loueurs, assurances, VTC et flottes d'entreprises. Bénéficiez de conditions avantageuses.
            </p>
            <div className="grid sm:grid-cols-2 gap-4 mt-8">
              {PERKS.map(({ Icon, label }) => (
                <div key={label} className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-brand-50 flex items-center justify-center shrink-0">
                    <Icon size={18} className="text-brand" />
                  </div>
                  <span className="text-sm font-semibold text-txt-900">{label}</span>
                </div>
              ))}
            </div>
            <Link
              to="/professionnels"
              className="mt-8 inline-flex items-center gap-2 bg-brand hover:bg-brand-600 text-white font-bold rounded-xl px-6 py-3.5 transition-colors"
              data-testid="b2b-cta"
            >
              Devenir partenaire <ArrowRight size={16} />
            </Link>
          </div>
          <div
            className="hidden lg:block"
            style={{
              backgroundImage: "url('https://images.pexels.com/photos/4391469/pexels-photo-4391469.jpeg?auto=compress&cs=tinysrgb&w=600')",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
        </div>
      </div>
    </section>
  );
}
